import axios from "axios";

const API = import.meta.env.VITE_BASE_URL + "/api/telefect/v1/cart";
const API_PAYMENT = import.meta.env.VITE_BASE_URL + "/api/telefect/v1/payment";
const USER_API = import.meta.env.VITE_BASE_URL + "/api/telefect/v1/admin";

export const addToCartProduct = (data) => axios.post(`${API}/add`, data);
export const getCart = (userId) => axios.get(`${API}/${userId}`);
export const updateCartItem = (data) => axios.put(`${API}/update`, data);
export const removeCartItem = (userId,itemId) => axios.delete(`${API}/${userId}/item/${itemId}`);
export const clearCartProduct = (userId) => axios.delete(`${API}/clear/${userId}`);
// paymentApi.js
export const createPayment = (payload) => axios.post(`${API_PAYMENT}/create`, payload);


// user
export const getMyOrders = (id,token) => 
    axios.get(`${USER_API}/my-orders/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});

